import { Component } from '@angular/core';

import { ApiCallCachingService } from '../../services/api-call-caching.service';

import { DropdownBaseComponent } from './dropdown-base/dropdown-base.component';

import { BooleanModel } from '../../models/boolean.model';

import { Observable } from 'rxjs';

@Component({
  selector: 'spv2-boolean-dropdown',
  templateUrl: './dropdown-base/dropdown-base.component.html',
  styleUrls:['./dropdown-base/dropdown-base.component.scss']
})
export class BooleanDropdownComponent extends DropdownBaseComponent<void, BooleanModel> {

  uniqueName = "boolean";

  textField = "text";
  valueField = "bool";

  enableCache = true;

  dataFunction = () => {
    return new Observable<BooleanModel[]>(x => {
      x.next([new BooleanModel(true, "Yes"), new BooleanModel(false, "No")]);
      x.complete();
    })
  };

  constructor(cachingService: ApiCallCachingService) {
    super(cachingService);
  }

}
